import { annotationTypes } from './types';
import { CovideoIcon } from 'lib/components/CovideoIcon';
import React from 'react';
import { TFunction } from 'i18next';

export const getPositions = (t: TFunction) => [
  { label: t('Top Left'), value: 'Top Left' },
  { label: t('Top Center'), value: 'Top Center' },
  { label: t('Top Right'), value: 'Top Right' },
  { label: t('Bottom Left'), value: 'Bottom Left' },
  { label: t('Bottom Center'), value: 'Bottom Center' },
  { label: t('Bottom Right'), value: 'Bottom Right' },
  { label: t('Center'), value: 'Center' },
];

export const getPositionsWithIcons = (t: TFunction) => [
  {
    value: 'Bottom Center',
    label: t('Bottom Center'),
    icon: <CovideoIcon name='bottom-center' width={20} />,
    for: annotationTypes.ANNOTATION_TEXT,
  },
  {
    value: 'Bottom Left',
    label: t('Bottom Left'),
    icon: <CovideoIcon name='bottom-left' width={20} />,
    for: annotationTypes.ANNOTATION_TEXT,
  },

  {
    value: 'Bottom Right',
    label: t('Bottom Right'),
    icon: <CovideoIcon name='bottom-right' width={20} />,
    for: annotationTypes.ANNOTATION_TEXT,
  },

  {
    value: 'Top Left',
    label: t('Top Left'),
    for: annotationTypes.ANNOTATION_IMAGE,
    icon: <CovideoIcon name='top-left' width={20} />,
  },
  {
    value: 'Top Right',
    label: t('Top Right'),
    for: annotationTypes.ANNOTATION_IMAGE,
    icon: <CovideoIcon name='top-right' width={20} />,
  },
];
